module.exports = __webpack_public_path__ + "static/media/11_3.8ae6bc6f.jpg";